import React from 'react';
import Header from '../components/header.component';
import { Footer } from '../components/footer.component';
import SectionHeader from '../components/common';
import { useTranslation } from 'react-i18next';
import '../scss/self-employed-invoicing.style.scss';
import FreelancerCtaSection from '../components/freelancer-call-to-action';
import { InvozioAsFreelancer } from '../components/images/png/icons';
import SelfEmployedInvoicingPageComponent from '../components/self-employed-invoicing.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';

export const SelfEmployedInvoicingPage: React.FC = () => {
      const { t, i18n } = useTranslation();
    
        const currentLanguage = i18n.language;
    
        const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
        const canonicalUrl = isEnglish
            ? `https://www.invozio.com/invoicing-as-an-individual_self-employed?lang=${LOCALES.EN_US}`
            : `https://www.invozio.com/fakturera-som-privatperson_egenanstalld?lang=${LOCALES.SV_SE}`;
    
       
        const schemaMarkup = getSchemaMarkup("fakturera-som-privatperson_egenanstalld");
    return (
        <>
            <Header />
             <SEOMetadataComponent
                title={t('SELF_EMPLOYED_INVOICING')}
                // description={t('FEATURES_MAIN_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
            <SectionHeader
                titleKey={t('SELF_EMPLOYED_INVOICING')}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />
            <SelfEmployedInvoicingPageComponent/>
            <FreelancerCtaSection
                title={t('LET_INVOZIO_HELP_YOU_AS_FREELANCER')}
                description={[t('FREELANCING_REWARDING_CAREER_TEXT_1'), t('FREELANCING_REWARDING_CAREER_TEXT_2')]}
                buttonText={t('CREATE_FREE_ACCOUNT')}
                imageSrc={InvozioAsFreelancer}
                imageAlt="Freelancer illustration"
            />
            <div className="bg-footer">
                <Footer />
            </div>
        </>
    );
};

export default SelfEmployedInvoicingPage;
